module.exports = __webpack_public_path__ + "static/media/camera.c7e00707.svg";